// import external dependencies
import 'jquery'
import 'jquery-touchswipe'

// eslint-disable-next-line no-unused-vars
import { Howl } from 'howler'
// Import everything from autoload


// import local dependencies
import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import aboutUs from './routes/about'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
})

// Load Events
jQuery(document).ready(() => routes.loadEvents())


var head = document.getElementsByTagName('head')[0];

// Save the original method
var insertBefore = head.insertBefore;

// Replace it!
head.insertBefore = function (newElement, referenceElement) {
  // if (newElement.src && newElement.src.indexOf('platform-api.sharethis.com') !== -1) {
  //   // console.info('stop src');
  //   return;
  // }
  if (newElement.href && newElement.href.indexOf('https://fonts.googleapis.com') === 0) {
    // console.info('stop href');
    return;
  }

  insertBefore.call(head, newElement, referenceElement);
};
// // eslint-disable-next-line no-unused-vars
// function globalMapLoad() {
//   if (jQuery('#interactive-map')) {
//     // eslint-disable-next-line no-undef
//     initMap()
//   }
// }
